export { default as default } from './Compartir';
